import React from 'react';
import PropTypes from 'prop-types';
import { C } from 'shared/helpers';

import Styles from './Frame.module.scss';

import Header from './Header/Header';
import Table from './Table/Table';

export default function Frame({
  n,
  etapaid,
  fenologica,
  aplicacao,
  fprodutos,
  quantidades,
  valores,
  open,
  setPane,
  phase,
  produtos,
  setter,
  renderables,
  tableKey,
  medida,
  updateMedida,
}) {
  const { Frame, Open } = Styles;

  return (
    <div className={C(Frame, [open, Open])}>
      <Header n={n} name={fenologica} toggle={setPane} />
      {open && (
        <Table
          n={n}
          fenologica={fenologica}
          aplicacao={aplicacao}
          produtos={produtos}
          fprodutos={fprodutos}
          quantidades={quantidades}
          valores={valores}
          etapaid={etapaid}
          phase={phase}
          setter={setter}
          renderables={renderables}
          tableKey={tableKey}
          medida={medida}
          updateMedida={updateMedida}
        />
      )}
    </div>
  );
}

Frame.defaultProps = {
  fenologica: '',
  aplicacao: '',
  produtos: [],
  fprodutos: {},
  quantidades: {},
  valores: {},
  tableKey: 'nutritionalEditor_Frame_',
  etapaid: null,
};

Frame.propTypes = {
  n: PropTypes.number.isRequired,
  fenologica: PropTypes.string,
  aplicacao: PropTypes.string,
  quantidades: PropTypes.any,
  valores: PropTypes.any,
  produtos: PropTypes.array,
  fprodutos: PropTypes.object,
  open: PropTypes.bool.isRequired,
  setPane: PropTypes.func.isRequired,
  phase: PropTypes.number.isRequired,
  setter: PropTypes.func.isRequired,
  renderables: PropTypes.any.isRequired,
  tableKey: PropTypes.string,
  etapaid: PropTypes.any,
};
